<template>
    <el-dialog title="发放记录" :visible="visibleRecord" width="70%" @close="closeDialog" :close-on-click-modal="false"
        append-to-body>
        <basic-container>
            <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
                @search-change="searchChange" @refresh-change="refreshChange(page)"
                @selection-change="handleSelectionChange" @size-change="pageSizeChange" @current-change="pageChange">
                <template slot-scope="scope" slot="menuLeft">
                    <el-button size="mini" type="danger" @click="handleDel(scope.row)" icon="el-icon-delete" plain>
                        删除
                    </el-button>
                </template>
                <template slot-scope="scope" slot="menu">
                    <el-button size="mini" type="text" @click="handleDel(scope.row)" icon="el-icon-delete">
                        删除
                    </el-button>
                </template>
            </avue-crud>
        </basic-container>
        <span slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">关闭</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { sendRecordOption } from "./sendRecordOption";
import { getSendRecord, delCouponSendRecord } from "@/api/work/waterProject/coupon";
export default {
    name: "SendRecord",
    props: {
        visibleRecord: {
            type: Boolean,
            required: true,
        },
        couponId: {
            type: [String, Number],
            required: true,
        },
    },
    data() {
        return {
            tableOption: sendRecordOption, //表格设置属性
            tableData: [], //表格的数据
            tablePage: 1,
            tableLoading: false,
            loading: false,
            page: {
                total: 0, //总页数
                currentPage: 1, //当前页数
                pageSize: 10, //每页显示多少条
            },
        };
    },
    created() {
        // 初始加载时如果 couponId 已经有值，调用 handleList
        if (this.couponId) {
            this.handleList();
        }
    },
    watch: {
        /* // 监听 couponId 的变化
        couponId(newCouponId) {
            if (newCouponId) {
                this.handleList();
            }
        }, */
        // 监听 visibleRecord 的变化
        visibleRecord(newVisibleRecord) {
            if (newVisibleRecord) {
                this.handleList();
            } 
        }
    },
    methods: {
        /**
         * @title 数据删除
         * @param row 为当前的数据
         * @param index 为当前更新数据的行数
         *
         **/
        handleDel(row) {
            let ids = "";
            ids = this.ids;
            if (row) {
                ids = row.id;
                this.$confirm(`您确定删除该条数据吗？`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        delCouponSendRecord(ids)
                            .then(res => {
                                if (res.code == "200") {
                                    this.$message({
                                        showClose: true,
                                        message: "成功删除",
                                        type: "success"
                                    });
                                    this.handleList();
                                } else {
                                    this.$message({
                                        showClose: true,
                                        message: res.message ? res.message : '删除失败,请重试',
                                        type: "error"
                                    });
                                }
                            })
                            .catch(error => {
                                this.loading = false;
                                this.$message({
                                    showClose: true,
                                    message: error,
                                    type: "error"
                                });
                            });
                    })
                    .catch(() => { });
            } else {
                if (!ids) {
                    this.$message({
                        showClose: true,
                        message: "未选中任何数据",
                        type: "error"
                    });
                    return;
                }
                let length = ids.split(",").length;
                this.$confirm(
                    `共选中${length}条数据吗，您确定批量删除吗？`,
                    "提示",
                    {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    }
                )
                    .then(() => {
                        delCouponSendRecord(ids)
                            .then(res => {
                                if (res.code == "200") {
                                    this.$message({
                                        showClose: true,
                                        message: "成功",
                                        type: "success"
                                    });
                                    this.handleList();
                                } else {
                                    this.$message({
                                        showClose: true,
                                        message: res.message,
                                        type: "error"
                                    });
                                }
                            })
                            .catch(error => {
                                this.loading = false;
                                this.$message({
                                    showClose: true,
                                    message: error,
                                    type: "error"
                                });
                            });
                    })
                    .catch(() => { });
            }
        },
        handleList() {
            this.tableLoading = true;
            let params = {
                page: this.page.currentPage,
                size: this.page.pageSize,
            };
            this.downloadData = params;
            getSendRecord(this.couponId, params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: this.page.currentPage,
                    pageSize: this.page.pageSize,
                };
                this.tableLoading = false;
            });
        },
        pageSizeChange(pageSize) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            params.page = this.page.currentPage;
            params.size = pageSize;
            this.downloadData = params;
            getSendRecord(this.couponId, params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: this.page.currentPage,
                    pageSize: pageSize,
                };
                this.tableLoading = false;
            });
        },
        pageChange(page) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            params.page = page;
            params.size = this.page.pageSize;
            this.downloadData = params;
            getSendRecord(this.couponId, params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: page,
                    pageSize: this.page.pageSize,
                };
                this.tableLoading = false;
            });
        },
        searchChange(params) {
            this.tableLoading = true;
            params.page = this.page.currentPage;
            params.size = this.page.pageSize;
            getSendRecord(this.couponId, params).then((res) => {
                if (res.code != 500) {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: params.page,
                        pageSize: params.size,
                    };
                    this.tableLoading = false;
                } else {
                    this.tableLoading = false;
                    this.tableData = [];
                }
            });
        },
        //eslint-disable-next-line
        refreshChange(page) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            params.page = page.currentPage;
            params.size = page.pageSize;
            this.downloadData = params;
            getSendRecord(this.couponId, params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: page.currentPage,
                    pageSize: page.pageSize,
                };
                this.tableLoading = false;
            });
        },
        handleSelectionChange(selection) {
            this.selectedShops = selection;
        },
        closeDialog() {
            this.$emit("update:visibleRecord", false);
        },
        resetSelection() {
            this.selectedProducts = [];
            this.handleList();
        },
    },
};
</script>

<style scoped>
.filter-bar {
    margin-bottom: 20px;
    display: flex;
    gap: 10px;
}

.filter-item {
    flex: 1;
}

.dialog-footer {
    text-align: right;
}
</style>